/*
 * Event Details GraphQL specification
 * @module src/graphql/getInventoryRequestDetails
 */
/* eslint-disable import/prefer-default-export */
import gql from 'graphql-tag';

/**  Event Details GraphQL API query */
export const GET_INVENTORY_REQUEST_DETAILS = gql`
  query getInventoryRequestDetails($id: String, $externalId: String, $searchText: String) {
    getInventoryRequestDetails(id: $id, externalId: $externalId, searchText: $searchText) {
      caseId
      caseExternalId
      salesRepId
      salesRep
      eventType
      eventId
      division
      eventStatus
      serviceLevel
      serviceLevelJustification
      shipMethod
      orderType
      needByDate
      parentEventId
      parentEventType
      parentOrderid
      parentEventStatus
      parentEventDescription
      parentEventSubType
      parentCaseExternalId
      parentCaseId
      branchId
      branch
      accountId
      accountNumber
      accountName
      createdDate
      createdDate
      updatedDate
      updatedBy
      createdBy
      caseVersion
      submittedDate
      shippingAddessLine1
      shippingAddessLine2
      shippingPostalcode
      shippingCity
      shippingState
      shippingId
      shippingAddressNumber
      cancelReason
      territoryNumber
      regionName
      subInventoryCode
      totalCost
      isShippingDetails
      visualIndicator
      liftGateNeeded
      dockAvailable
      shortTruckOnly
      deliveryContractName
      deliveryContractPhone
      isShippingDetails
      deliveryContractEmail
      deliveryContractInstructions
      parentEventStartDate
      thresholdQuantityIndicator
      cancelComment
      salesRepNameIns
      salesRepEmailIns
      salesRepPhoneIns
      shippingInstructions
      checkRejectLineStatus
      comments {
        id
        externalId
        value: comments
        type
        user
        postTime
      }
      lineItems {
        productOnHold
        usageId
        usageExternalId
        productNo
        productId
        quantity
        actualQuantity
        status
        workflowAction
        productdescription
        cost
        lineVisualIndicator
        productFamily
        packContent
        salesUnitOfMeasure
        lineThresholdQuantityIndicator
        thresholdQuantity
        isAlreadyRequested
        baseorCapital
        isRejectedByBranchOps
        caseUsagesUpdatedByUser
      }
      attachments {
        id
        caseId
        caseExternalId
        recordType
        attachmentType
        showOnUsageSheet
        name
        createdBy
        createdAt
        imageurl
        user
      }
    }
  }
`;
